export default "__VITE_ASSET__mFX_5TZi__"